module.exports = __webpack_public_path__ + "static/media/m3.3413d9ef.jpg";